import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.css']
})
export class SuccessComponent implements OnInit {
usr: firebase.User;
  constructor(private angularFireAuth: AngularFireAuth) {
    this.angularFireAuth.auth.onAuthStateChanged(u=>{
      if(u){
        this.usr = u;
      }
    });


   }

  ngOnInit() {
  }

}
